<script setup>
import { defineProps } from "vue"

const props = defineProps({
  txt: {
    type: [String, Number],
    default: ''
  }
})

</script>

<template>
    <div class="div-circle">
        <span class="span-txt">{{ props.txt }}</span>
    </div>
</template>

<style scoped>
    .div-circle {
        width: 20px;
        height: 20px;
        display: flex;
        border: 1px solid;
        border-radius: 50%;
        justify-content: center;
        background-color: var(--default-font-color);
    }

    .span-txt {
        color: var(--default-app-alt-line-color);
    }

    @media screen and (max-width: 765px) {
        .span-txt {
            margin-top: 2px;
        }
    }

</style>